const SECOND = 1000
const MINUTE = SECOND * 60
const HOUR = MINUTE * 60
const DAY = HOUR * 24

function parseDate(dateI) {
  if (!dateI) return null

  // Đã là Date
  if (dateI instanceof Date) {
    return Number.isNaN(dateI.getTime()) ? null : dateI
  }

  const value = String(dateI).trim()

  if (!value) return null

  let date

  // ISO có timezone: 2026-08-04T08:00:00Z
  // hoặc: 2026-08-04T15:00:00+07:00
  if (value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value)) {
    date = new Date(value)
  } else {
    // Backend Laravel thường trả:
    // 2026-08-04 15:00:00
    //
    // Xác định đây là giờ Việt Nam
    const normalized = value.replace(' ', 'T')

    date = new Date(`${normalized}+07:00`)
  }

  return Number.isNaN(date.getTime()) ? null : date
}

function formatDateVN(dateI) {
  const date = parseDate(dateI)

  if (!date) {
    // Quan trọng: không làm mất dữ liệu gốc
    return String(dateI ?? '')
  }

  return new Intl.DateTimeFormat('vi-VN', {
    timeZone: 'Asia/Ho_Chi_Minh',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date)
}

function calcDate(dateI = '') {
  if (!dateI) return ''

  const date = parseDate(dateI)

  // Không parse được thì trả nguyên dữ liệu
  if (!date) {
    return String(dateI)
  }

  const diff = Date.now() - date.getTime()

  // Ngày trong tương lai
  if (diff < 0) {
    return formatDateVN(dateI)
  }

  if (diff < MINUTE) {
    const seconds = Math.floor(diff / SECOND)

    return seconds <= 1 ? 'vài giây trước' : `${seconds} giây trước`
  }

  if (diff < HOUR) {
    return `${Math.floor(diff / MINUTE)} phút trước`
  }

  if (diff < DAY) {
    return `${Math.floor(diff / HOUR)} giờ trước`
  }

  const days = Math.floor(diff / DAY)

  if (days <= 31) {
    return `${days} ngày trước`
  }

  const months = Math.floor(days / 31)

  if (months <= 24) {
    return `${months} tháng trước`
  }

  // > 2 năm
  return formatDateVN(dateI)
}

export default {
  calcDate,
}
